let NextHolidayItems = [
    {
        id: 1,
        itemTitle: 'Maldives from £499pp'
    },
    {
        id: 2,
        itemTitle: 'Dubai from £299pp'
    },
    {
        id: 3,
        itemTitle: 'London from £189pp'
    },
    {
        id: 4,
        itemTitle: 'Paris from £199pp'
    },
    {
        id: 5,
        itemTitle: 'Greek Islands from £149pp'
    },
    {
        id: 6,
        itemTitle: 'Barcelona from £199pp'
    },
    {
        id: 7,
        itemTitle: 'Cairo from £499pp'
    },
    {
        id: 8,
        itemTitle: 'Istanbul from £399pp'
    },
    {
        id: 9,
        itemTitle: 'Bangkok from £299pp'
    }
];

export default NextHolidayItems;
